/**
 * Hierarchically traverse a node's parents until a matching selector is found.
 *
 * @function
 * @memberof Element.prototype
 * @name parents
 * @param {String} selector - The CSS selector to match against the parents.
 * @returns {null|HTMLElement} - The first parent element that matches the selector,
 *   or null if no matching parent is found.
 */
Element.prototype.parents = function (selector) {
  let node = this;

  while (
    (node = node.parentElement) &&
    !((node.matches || node.matchesSelector).call(node, selector))
  );

  return node;
};

export default Element.prototype.parents;
